<div class="fullscreen-container"
    [ngStyle]="{'grid-template-columns': collapsed ? '70px calc(100vw - 70px)' : '230px calc(100vw - 230px)'}">
    <div class="left-container">
        <app-navbar (collapsedChanged)="onCollapsedChanged($event)"></app-navbar>
    </div>
    <div class="right-container">
        <app-header [config]="headerConfig"></app-header>
        <router-outlet></router-outlet>
    </div>
</div>
<app-bottom-sheet></app-bottom-sheet>
